import { render, staticRenderFns } from "./aftersale_order_edit.vue?vue&type=template&id=4c695b8e&scoped=true"
import script from "./aftersale_order_edit.vue?vue&type=script&lang=js"
export * from "./aftersale_order_edit.vue?vue&type=script&lang=js"
import style0 from "./aftersale_order_edit.vue?vue&type=style&index=0&id=4c695b8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c695b8e",
  null
  
)

export default component.exports